<template>
  <v-menu class="app-menu" transition="slide-y-transition" bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div class="app-menu-group">
        <v-btn class="transparent" dark v-bind="attrs" v-on="on" icon small>
          <img class="app-menu-icon" :src="app_menu" alt="Apps Menu" />
        </v-btn>
      </div>
    </template>

    <v-list class="app-menu-container pa-5">
      <p class="kt-menu__link-text app-menu-title">Apps Menu</p>
      <v-divider />

      <v-list-item-group v-if="!loading" color="primary">
        <div v-for="(client, index) in accessClients" :key="index">
          <a :href="client.link" target="_blank" v-if="client.access">
            <v-list-item>
              <v-list-item-icon>
                <img
                  class="app-menu__icons"
                  :src="client.cover_photo"
                  alt="App Menu"
                  max-width="20"
                />
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="subtitle-1">{{
                  client.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </a>
        </div>
      </v-list-item-group>

      <p class="body" v-if="loading">Loading... Please wait</p>
      <p class="body no-access-msg" v-if="!hasAccessClients && !loading">
        No data available
      </p>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  computed: {
    hasAccessClients() {
      let hasAccess = this.accessClients.map((client) => client.access == true);
      return hasAccess.includes(true);
    },
  },
  data() {
    return {
      loading: false,
      app_menu: require('@/assets/images/site-menu.png'),
      accessClients: [],
    };
  },
  mounted() {
    this.renderSiteApp();
  },
  methods: {
    renderSiteApp() {
      if (process.env.VUE_APP_DISABLE_SSO) {
        return;
      }
      this.loading = true;
      this.$http
        .get(`central/get-app-menu`)
        .then((data) => {
          this.accessClients = data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
};
</script>
